/** Maps a CMS `icon` name (kebab-case) to a lucide-react component. */
import {
    BookOpen,
    Shield,
    Briefcase,
    HardHat,
    Landmark,
    PenLine,
    Globe,
    Scale,
    Lock,
    Handshake,
    Languages,
    Building2,
} from "lucide-react";

const REGISTRY = {
    "book-open": BookOpen,
    shield: Shield,
    briefcase: Briefcase,
    "hard-hat": HardHat,
    landmark: Landmark,
    "pen-line": PenLine,
    globe: Globe,
    scale: Scale,
    lock: Lock,
    handshake: Handshake,
    languages: Languages,
    "building-2": Building2,
};

export function CmsIcon({ name, size = 22, className = "text-gold", strokeWidth = 1.5 }) {
    const Icon = REGISTRY[name] || Scale;
    return <Icon size={size} className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
